import React from 'react';
import CSS from 'react-css-modules';
import classnames from 'classnames';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';

import chatieLogo from 'assets/images/chatie_logo_n.png';
import chatieLogoW from 'assets/images/chatie_logo.png';

import styles from './style.scss';

class Header extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    themeDark: PropTypes.bool,
  }

  static defaultProps = {
    theme: false,
  }

  render() {
    const { themeDark } = this.props;
    const { pathname } = this.props.history.location;
    const menus = [
      { to: '/', label: '채티 소개' },
      // { to: '/writer', label: '작가 모집' },
      { to: '/studio', label: 'PC스튜디오' },
    ]
    return (
      <div styleName={classnames('header', themeDark && 'header--dark')}>
        <Link to="/">
          <img src={themeDark ? chatieLogo : chatieLogoW} alt="채티" />
        </Link>
        <ul>
          {menus.map(menu => (
            <Link to={menu.to} key={`menu-${menu.to}`}>
              <li styleName={pathname === menu.to ? 'active' : ''}>{menu.label}</li>
            </Link> 
          ))}
        </ul>
      </div>
    );
  }
}

const Component = CSS(Header, styles, { allowMultiple: true });

export default withRouter(Component);



// WEBPACK FOOTER //
// ./src/app/components/common/Header/index.js